import { motion } from "framer-motion";

const WHITE = "#FFFFFF";
const CREAM = "#FAF7F2";
const INK = "#16362A";
const LEAF = "#2F6B3F";
const SAGE = "#E9F0E7";
const BODY = "#4A6054";
const MAROON = "#5C1A1A";

const IMG = "?crop=entropy&cs=srgb&fm=jpg&q=85&w=800";

const CARDS = [
  {
    id: "range-card-1",
    name: "Everyday Masala",
    type: "Oats Chilla Mix",
    desc: "Oats, cumin, coriander, onion and green chilli.",
    protein: "20g",
    fiber: "8g",
    img: "https://static.prod-images.emergentagent.com/jobs/002aba5c-2c34-4dde-9d34-f67edaa196a8/images/0badcaf4f816d569aa11def3d6e1c5b1271208fd4a833c5b2232434639a6572f.jpeg",
  },
  {
    id: "range-card-2",
    name: "Classic Tandoori",
    type: "Oats Chilla Mix",
    desc: "Oats, tandoori spices, ginger, garlic and smoked paprika.",
    protein: "20g",
    fiber: "8g",
    img: "https://static.prod-images.emergentagent.com/jobs/002aba5c-2c34-4dde-9d34-f67edaa196a8/images/f9552f557527821e582f960fb343ab366ea1d4e80e0ca36478e84a8d9ad2902b.jpeg",
  },
  {
    id: "range-card-3",
    name: "Chilli Cheese",
    type: "Supergrain Chilla Mix",
    desc: "Millets, plant protein, chickpea flour, green chillies and real cheese.",
    protein: "20g",
    fiber: "8g",
    img: "https://static.prod-images.emergentagent.com/jobs/002aba5c-2c34-4dde-9d34-f67edaa196a8/images/4a75e4cd57a53fbb152a0785db0beaf601622ada0794dd6ae64e6ad9d0d7e7c8.jpeg",
  },
  {
    id: "range-card-4",
    name: "Avocado & Herbs",
    type: "Supergrain Chilla Mix",
    desc: "Millets, plant protein, ragi, avocado, parsley and black pepper.",
    protein: "20g",
    fiber: "8g",
    img: "https://static.prod-images.emergentagent.com/jobs/002aba5c-2c34-4dde-9d34-f67edaa196a8/images/c02c388334e33ee597789cc180dfaf8783d1a75d5267f0b562359a0b1b520b14.jpeg",
  },
];

export default function StartingRange() {
  return (
    <section id="range" data-testid="products-section" style={{ backgroundColor: WHITE }} className="py-20 sm:py-28 px-6 sm:px-10 lg:px-16">
      <div className="max-w-6xl mx-auto">
        <motion.p
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-[11px] font-bold uppercase tracking-[0.26em] mb-4"
          style={{ color: LEAF }}
        >
          The Range
        </motion.p>

        <motion.h2
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.06 }}
          className="text-4xl sm:text-5xl lg:text-[3.4rem] leading-tight mb-3"
          style={{ fontFamily: "'Playfair Display', serif", fontWeight: 700, color: INK }}
        >
          Our Starting Range
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.12 }}
          className="text-base sm:text-lg mb-14 max-w-lg"
          style={{ color: "#386546" }}
        >
          Four everyday chillas — all high in protein and fiber.{" "}
          <strong style={{ color: LEAF, whiteSpace: "nowrap" }}>All Freshly FLAVRD.</strong>
        </motion.p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-7">
          {CARDS.map((card, i) => (
            <ProductCard key={card.id} card={card} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}

function ProductCard({ card, index }) {
  return (
    <motion.div
      data-testid={card.id}
      initial={{ opacity: 0, y: 34 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.65, ease: [0.22, 1, 0.36, 1], delay: index * 0.09 }}
      className="range-card rounded-2xl overflow-hidden flex flex-col"
      style={{ backgroundColor: CREAM, border: "1px solid rgba(47,107,63,0.12)" }}
    >
      <div className="relative" style={{ aspectRatio: "1 / 1", overflow: "hidden" }}>
        <img src={card.img} alt={card.name} className="w-full h-full object-cover" loading="lazy" />
      </div>

      <div className="px-5 pt-5 pb-6 flex flex-col flex-1">
        <p className="text-[10px] font-bold uppercase tracking-widest mb-1.5" style={{ color: LEAF }}>
          {card.type}
        </p>
        <h3 className="text-xl leading-snug mb-2" style={{ fontFamily: "'Playfair Display', serif", fontWeight: 700, color: INK }}>
          {card.name}
        </h3>
        <p className="text-sm leading-relaxed mb-5 flex-1" style={{ color: BODY }}>
          {card.desc}
        </p>

        <div className="flex items-center gap-3 mb-5">
          <Stat value={card.protein} label="Protein" />
          <div style={{ width: "1px", height: "26px", backgroundColor: "rgba(47,107,63,0.16)" }} />
          <Stat value={card.fiber} label="Fiber" />
        </div>

        <div className="flex items-center justify-between">
          <span
            className="text-[10px] font-bold uppercase tracking-widest px-3 py-1.5 rounded-full"
            style={{ backgroundColor: SAGE, color: LEAF }}
          >
            Coming Soon
          </span>
          <span
            className="text-[10px] font-semibold uppercase tracking-[0.12em]"
            style={{ color: BODY }}
          >
            4 Servings
          </span>
        </div>
      </div>
    </motion.div>
  );
}

function Stat({ value, label }) {
  return (
    <div>
      <p className="text-xl leading-none" style={{ fontFamily: "'Playfair Display', serif", fontWeight: 700, color: LEAF }}>
        {value}
      </p>
      <p className="text-[9px] font-bold uppercase tracking-wide mt-1" style={{ color: "#7C8F84" }}>
        {label}
      </p>
    </div>
  );
}
